export enum KnownBaleChamberType {
    FIXED_CHAMBER = 'FIXED_CHAMBER',
    SEMI_VARIABLE_CHAMBER = 'SEMI_VARIABLE_CHAMBER',
    VARIABLE_CHAMBER = 'VARIABLE_CHAMBER',
}
